import { createIntl, createIntlCache, IntlConfig } from "@formatjs/intl";
import { ILocaleCreatorInput, TMessages } from "./types";
import { ReactElement } from "react";

const cache = createIntlCache();

function createI18n({
  locale,
  globedMessages,
  defaultRichTextElements,
}: ILocaleCreatorInput) {
  if (import.meta.env.DEV) {
    locale = locale ?? "en";
  }

  let messages: TMessages | null = null;

  for (const messagesFilePath in globedMessages) {
    if (messagesFilePath.endsWith(`compiled-${locale}.json`)) {
      messages = globedMessages[messagesFilePath];
      break;
    }
  }

  if (messages == null) {
    throw new Error("No locale message found for " + locale);
  }

  const config: IntlConfig<string | ReactElement> = { locale, messages };
  if (defaultRichTextElements) {
    config.defaultRichTextElements = defaultRichTextElements;
  }

  const intl = createIntl<string | ReactElement>(config, cache);

  return intl;
}

// function localeForDebugger() {
//   const localeQuery = "locale";

//   return new URLSearchParams(window.location.search).get(localeQuery) ?? "en";
// }

export * from "./types";
export { createI18n };
